module.exports = __webpack_public_path__ + "static/media/arrow-04-svgrepo-com.4e454a74.svg";